module.exports = false;



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/modules/_library.js
 ** module id = 2209
 ** module chunks = 3
 **/